export const partHiddenEmail = (email: string): string => {
  if (!email) return email;
  const emailArr = email.split('@');
  const firstLettersLen = Math.floor(emailArr[0].length / 2);
  return `${emailArr[0].substring(
    0,
    firstLettersLen > 4 ? 4 : firstLettersLen
  )}***@${emailArr[1]}`;
};

export const formatNumber = (number: number | string, fallbackReturn: number | string = 0, toFixed = 2) => {
  const n = parseFloat(number as string);
  if (Number.isNaN(n)) return fallbackReturn || '0';
  if (Number(n) === n && n % 1 !== 0) {
    // is float
    return n.toFixed(toFixed).replace(/\d(?=(\d{3})+\.)/g, '$& ');
  }
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
